import { hasPermission } from "../../Config/permissions.js";

const AS_USER_TYPES = new Set(["Admin", "ASD", "Authorizer", "Viewer"]);

const isTrueValue = (value) => {
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
};

export const canDeleteIvrSubmission = (user, ivrData) =>
  Boolean(
    user &&
      AS_USER_TYPES.has(user.Type) &&
      hasPermission(user, "ivr.delete") &&
      ivrData &&
      isTrueValue(ivrData.IsActive),
  );
